import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=82431288&scoped=true&"
import script from "./ViewForm.vue?vue&type=script&lang=ts&"
export * from "./ViewForm.vue?vue&type=script&lang=ts&"
import style0 from "./ViewForm.vue?vue&type=style&index=0&id=82431288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82431288",
  null
  
)

export default component.exports